import * as React from 'react';
import { v4 as uuidv4 } from "uuid";
import { Filter } from '../model/searchresultModel';

interface FilterModel {
    filter: Filter[],
    onToggle: (filterKey: string, filterId: number) => void;
    selectedFilterCategory: Record<string, number[]>;
    loading: boolean;
}

const FilterBox: React.FC<FilterModel> = (props) => {

    const checked = (id: number) => {
        for (const key in props.selectedFilterCategory) {
            const arr = props.selectedFilterCategory[key];
            if (Array.isArray(arr) && arr.includes(id)) {
                return true;
            }
        }
        return false;
    };
    
    return (
        <div className="mb-6">
            {/*<h2 className="text-2xl font-semibold mb-2">
                Populære filtre
            </h2>*/}
            <div className="bg-brown-50 p-4 rounded-lg flex flex-col gap-3 mb-5 laptop:mb-6">
                {props.filter.map((element: Filter) => {
                    return (
                        <label key={uuidv4()} htmlFor={element.filterId} className={`ofg-label ofg-filter_checkbox ${props.loading || element.count === 0 ? 'ofg-label-disabled' : ''}`}>
                            <input type="checkbox" id={element.filterId} onChange={() => props.onToggle(element.filterKey,  Number(element.filterId))} checked={checked(Number(element.filterId))} disabled={props.loading || element.count === 0}/>
                            {element.filterName}
                        </label>
                    )
                })}
            </div>
        </div>
    );
};

export default FilterBox;
